export default "__VITE_ASSET__70c7151e__"